// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Account.yaml
// Generated: 2026-05-30T15:21:51.340Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAccount, UpdateAccount, Account } from '@/types/finance/Account';

/**
 * Account Service
 * CRUD operations for Account via the ABP API.
 */
export const accountService = new EntityService<Account, CreateAccount, UpdateAccount>(
  '/api/finance/account',
  'Account',
);
